import { render, staticRenderFns } from "./createBenefit.vue?vue&type=template&id=3fa2093e&scoped=true"
import script from "./createBenefit.vue?vue&type=script&lang=js"
export * from "./createBenefit.vue?vue&type=script&lang=js"
import style0 from "./createBenefit.vue?vue&type=style&index=0&id=3fa2093e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2093e",
  null
  
)

export default component.exports